"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingTotalsTable = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const react_1 = __importDefault(require("react"));
const NumericFormatTwoDecimals_1 = require("../numeric-format/NumericFormatTwoDecimals");
const DeleteTotalDiscountAction_1 = require("./actions/DeleteTotalDiscountAction");
require("./BookingTotalsTable.scss");
const DiscountLine_1 = require("./cell-renderer/DiscountLine");
const PaymentLine_1 = require("./cell-renderer/PaymentLine");
const VoidedLine_1 = require("./cell-renderer/VoidedLine");
const BookingTotalsTable = (props) => {
    const totals = props.booking.calcTotals();
    function handleDiscountChange(discount) {
        props.onBookingChange({ discount });
    }
    function handleDiscountDelete() {
        props.onBookingChange({ discount: undefined });
    }
    function handlePaymentDelete(index) {
        const paymentsClone = (0, cloneDeep_1.default)(props.booking.payments);
        paymentsClone.splice(index, 1);
        props.onBookingChange({ payments: paymentsClone });
    }
    function handlePaymentChange(index, payment) {
        const paymentsClone = (0, cloneDeep_1.default)(props.booking.payments);
        paymentsClone[index] = payment;
        props.onBookingChange({ payments: paymentsClone });
    }
    function handleReverseVoided() {
        // Reset. Correct invoice state will be set by CustomerBooking.update().
        props.onBookingChange({ invoiceStatus: undefined });
    }
    return (react_1.default.createElement("table", { className: "booking-totals-table" },
        react_1.default.createElement("tbody", null,
            react_1.default.createElement("tr", { className: "total" },
                react_1.default.createElement("td", { className: "font-weight-bold" }, "Total"),
                react_1.default.createElement("td", { className: "font-weight-bold" },
                    react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: totals.totalPrice })),
                react_1.default.createElement("td", null)),
            props.booking.discount &&
                discountRow(props.booking.discount, totals.totalPrice, handleDiscountChange, handleDiscountDelete, props.editable),
            props.booking.hasVoidedInvoice() && (react_1.default.createElement(VoidedLine_1.VoidedLine, { booking: props.booking, voidedAmount: totals.voidedAmount, onReverseVoided: handleReverseVoided, editable: props.editable })),
            paymentRows(props.booking.payments, handlePaymentChange, handlePaymentDelete, props.editable),
            react_1.default.createElement("tr", { className: "balance" },
                react_1.default.createElement("td", { className: "font-weight-bold" }, "Offener Betrag"),
                react_1.default.createElement("td", { className: "font-weight-bold" },
                    react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: totals.outstandingBalance })),
                react_1.default.createElement("td", null)))));
};
exports.BookingTotalsTable = BookingTotalsTable;
function discountRow(discount, totalPrice, onDiscountChange, onDelete, editable) {
    return (react_1.default.createElement("tr", { className: "discount" },
        react_1.default.createElement("td", { className: "d-flex" },
            react_1.default.createElement(DiscountLine_1.DiscountLine, { discount: discount, onDiscountChange: onDiscountChange, editable: editable })),
        react_1.default.createElement("td", null,
            react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: -discount.calc(totalPrice) })),
        react_1.default.createElement("td", null, editable && react_1.default.createElement(DeleteTotalDiscountAction_1.DeleteTotalDiscountAction, { onDelete: onDelete }))));
}
function paymentRows(payments, onPaymentChange, onPaymentDelete, editable) {
    return payments.map((payment, index) => (react_1.default.createElement("tr", { key: index, className: "payment" },
        react_1.default.createElement(PaymentLine_1.PaymentLine, { payment: payment, onPaymentChange: (changedPayment) => onPaymentChange(index, changedPayment), onPaymentDelete: () => onPaymentDelete(index), editable: editable }))));
}
function taxRows(taxes, taxNumber) {
    const taxRows = taxes.map((tax, index) => (react_1.default.createElement("tr", { key: tax.taxRate, className: "tax" + (index === 0 ? " first" : "") },
        react_1.default.createElement("td", { colSpan: 2 },
            "inkl. ",
            tax.taxRate,
            "% MWST, CHF",
            " ",
            react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: tax.taxAmount })),
        react_1.default.createElement("td", null))));
    // Add a row for the tax number.
    taxRows.push(react_1.default.createElement("tr", { key: "tax-number", className: "tax" },
        react_1.default.createElement("td", { colSpan: 2 },
            "(",
            taxNumber,
            " MWST)"),
        react_1.default.createElement("td", null)));
    return taxRows;
}
